import { slugifyTitle } from "wmk-tag";
import { EventQuery } from "../fragments/NodeEventFields";

export const getEventPath = (event: EventQuery) => {
  return `/events/${slugifyTitle(event.title)}`;
};
